/**
 * Surface Filters Reset — Interactivity API store extension.
 *
 * Registers the shared surface-filters store namespace so this block
 * can reference its actions (removeFilter, clearFilters).
 * The actual actions are defined in surface-filters/view.ts.
 */

import { store } from "@wordpress/interactivity";

store("byggma-brann-og-lyd/surface-filters", {});
